const REQUIRED_PERSONAL_AGREEMENT_FIELDS = Object.freeze([
  ['first_name', 'Vorname'],
  ['last_name', 'Nachname'],
  ['email', 'E-Mail-Adresse'],
  ['birth_date', 'Geburtsdatum'],
  ['street', 'Straße und Hausnummer'],
  ['postal_code', 'PLZ'],
  ['city', 'Ort'],
  ['country', 'Land'],
]);

function hasText(value) {
  return String(value || '').trim().length > 0;
}

export function getMissingPersonalAgreementFields(data = {}) {
  return REQUIRED_PERSONAL_AGREEMENT_FIELDS
    .filter(([field]) => !hasText(data[field]))
    .map(([field, label]) => ({ field, label }));
}

export function isPersonalAgreementComplete(data = {}) {
  return getMissingPersonalAgreementFields(data).length === 0;
}
